export default "__VITE_ASSET__CfES5Vm8__"